<template>
  <table class="chart-labels-table">
    <tr class="chart-labels-table__header">
      <th
        v-for="label in labels"
        :key="label"
        class="chart-labels-table__header-cell">
        {{ label }}
      </th>
    </tr>
    <tr class="chart-labels-table__row">
      <td
        v-for="(dataset, index) in datasets"
        :key="index"
        class="chart-labels-table__row-cell">
        {{ dataset }}
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  props: {
    labels: {
      type: Array,
      required: true
    },
    datasets: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-labels-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid $grey11;
  text-align: center;
  font-size: $fs-xs;

  &__row {
    height: 24px;
    min-height: 24px;
  }

  &__header-cell {
    border: 1px solid $grey11;
    font-weight: normal;
    width: 8.33%;
    padding: 4px;
    min-height: 24px;
  }
  &__row-cell {
    border: 1px solid $grey11;
    padding: 4px;
    min-height: 24px;
  }
}
</style>